import { FC, ReactNode } from 'react';

export interface FormGroupProps {
  children?: ReactNode;
  className?: string;
  row?: boolean;
}

export const FormGroup: FC<FormGroupProps> = ({ children, className, row = false }) => {
  return (
    <div
      role={'group'}
      className={[row ? 'flex flex-row flex-wrap gap-2' : 'flex flex-col gap-2', className].filter(Boolean).join(' ')}
    >
      {children}
    </div>
  );
};
